<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.razonSocial" :label="$t('admin.company.labels.razonSocial')" icon="business"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.direccion" :label="$t('admin.company.labels.direccion')" icon="mdi-map-marker"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.telefono" :label="$t('admin.company.labels.telefono')" icon="mdi-phone"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.emailComercial" :label="$t('admin.company.labels.emailComercial')" icon="mdi-email-outline"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.emailContacto" :label="$t('admin.company.labels.emailContacto')" icon="mdi-email-lock"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.cuit" :label="$t('admin.company.labels.cuit')" icon="badge"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.nombreFantasia" :label="$t('admin.company.labels.nombreFantasia')" icon="store"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
     
    
    export default {
        name: 'CompanyShowData',
        components: {ShowField},
        
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

